import React, { useState, useEffect, useRef, useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './confirmationModal.css';

const ConfirmationModalPrijemnicaOtpremnica = ({
  visible,
  onHide,
  onConfirmContinue,
  onConfirmExit,
  onConfirmRemove,
  idItem,
  children
}) => {

  const header = (
    <div className="conf-modal-header-btns">
      <Button
        label={idItem ? "Sačuvaj i dodaj" : "Unesi i dodaj"}
        icon="pi pi-plus"
        onClick={onConfirmContinue}
        severity="success"
      />
      <Button
        label={idItem ? "Sačuvaj i izađi" : "Unesi i izađi"}
        icon="pi pi-sign-out"
        onClick={onConfirmExit}
        severity="warning"
      />
      {idItem && <Button
        label="Storno"
        icon="pi pi-trash"
        onClick={onConfirmRemove}
        severity="danger"
      />}
    </div>
  );

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: '50vw' }}
      breakpoints={{ '768px': '95vw' }}
      onHide={onHide}
      modal
      className="confirmation-modal"
    >
            {children}
    </Dialog>
  );
};

export default ConfirmationModalPrijemnicaOtpremnica;